import { render, staticRenderFns } from "./SidebarEditQuestion.vue?vue&type=template&id=b78b612a&scoped=true"
import script from "./SidebarEditQuestion.vue?vue&type=script&lang=js"
export * from "./SidebarEditQuestion.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditQuestion.vue?vue&type=style&index=0&id=b78b612a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78b612a",
  null
  
)

export default component.exports